import PropTypes from 'prop-types'

import theme from 'theme'

function Panel({ children, ...otherProps }) {
  return (
    <div
      css={{
        backgroundColor: theme.colors.panel[0],
        borderRadius: theme.borderRadius[0],
        padding: theme.space[4]
      }}
      {...otherProps}
    >
      {children}
    </div>
  )
}

Panel.propTypes = {
  children: PropTypes.node
}

export default Panel
